<template>
  <div>
    <helpers-section-header class="mt-6 mb-2"> Insider Buying Signal Rules </helpers-section-header>
    <p class="text-body-2 mb-6">
      Company insiders — officers, directors, and large shareholders — are required to file with the
      SEC when they buy or sell their own company's stock. Unlike institutional 13F filings, insider
      purchases are made with the insider's own money and carry a strong conviction signal: the
      insider believes the stock is undervalued. This signal identifies clusters of insider buying
      activity and uses them as buy triggers.
    </p>

    <helpers-section-sub-header class="mt-6 mb-2"> Signal Evaluation Window </helpers-section-sub-header>
    <p class="text-body-2 mb-2">
      How many days after a cluster is identified to keep treating it as an actionable buy signal.
      Short windows (5–10 days) act on recent activity only. Longer windows allow the signal to
      persist across the holding period.
    </p>
    <v-row style="margin-top: 20px">
      <v-col v-if="!appcriteria.general.screener" cols="12">
        <v-text-field
          v-model="criteria.number_of_days_to_evaluate"
          label="Days to keep insider signal active"
          suffix="days"
          variant="outlined"
          density="compact"
          hint="Number of days after filing released (plus trading delay) to continue to evaluate as a buy. Max 100 days / 200 signals."
          persistent-hint
          style="max-width: 250px"
        />
      </v-col>
    </v-row>

    <v-tabs v-model="tab" theme="dark">
      <v-tab value="1"> Transactions Filter </v-tab>
      <v-tab value="2"> Insider Restrictions </v-tab>
    </v-tabs>
    <v-tabs-window v-model="tab">
      <v-tabs-window-item value="1">
        <TransactionsFilter />
      </v-tabs-window-item>
      <v-tabs-window-item value="2">
        <InsiderRestrictions />
      </v-tabs-window-item>
    </v-tabs-window>
  </div>
</template>

<script>
// Modules
import { useUserStore, useAppStore, useWwStore } from '@/store'
// Modules
import { mapWritableState } from 'pinia'
import InsiderRestrictions from '@/components/page/whale-backtester/signals/_InsiderRestrictions'
import TransactionsFilter from '@/components/page/whale-backtester/signals/_TransactionsFilter'
import { markRaw } from 'vue'
export default {
  components: {
    TransactionsFilter: markRaw(TransactionsFilter),
    InsiderRestrictions: markRaw(InsiderRestrictions)
  },
  data() {
    return {
      tab: '1',
      allow_shorts: true,
      allow_longs: true,
      dialog: false,
      and_or: 'or'
    }
  },
  computed: {
    ...mapWritableState(useAppStore, ['whaleTraderCriteria', 'signalView', 'exit_time_periods']),
    criteria() {
      return this.whaleTraderCriteria.signals.insider_signal
    },
    appcriteria() {
      return this.whaleTraderCriteria
    },
    enabled() {
      return this.whaleTraderCriteria.signals.insider_signal.enabled
    }
    /*...mapFields({
      appcriteria: 'app.whaleTraderCriteria',
      criteria: 'app.whaleTraderCriteria.signals.insider_signal',
      enabled: 'app.whaleTraderCriteria.signals.insider_signal.enabled'
    })*/
  }
}
</script>
